import { InputTextArea, MasterButton } from "App/Component/ui"
import Modal from "App/Component/ui/Modal/Modal"
import React, { useState } from "react"
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Tooltip,
} from "@material-ui/core"
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
} from "App/utils/helpers"
import { renderJenisKunjungan } from "pages/BPJS/WsBPJS/RefAntreanBelum/const"
import { ANTREAN_JKN_STATUS, urlUpdateWaktuAntrean } from "./helpers"
import { Skeleton } from "@material-ui/lab"
import { instanceWsBPJS } from "App/constants"

export default function ModalDetailJkn({
  setShowModal,
  formData,
  dataJKN,
  setFormData,
  loadingJKN,
  withButtonDelete = true,
}) {
  const [openDelete, setOpenDelete] = useState()
  const [dataDelete, setDataDelete] = useState()

  const confirmDelete = async () => {
    const defaultMessageError = "Terjadi kesalahan saat membatalkan booking JKN"
    try {
      const payload = {
        kode_booking: formData.id?.toString(),
        Keterangan: formData.keterangan_batal_jkn,
      }
      const response = await instanceWsBPJS.post(urlUpdateWaktuAntrean, payload)
      const statusCode = response.data?.metadata?.code
      const message = response.data?.metadata?.message

      if (parseInt(statusCode) === 200) {
        defaultToastSuccess(message ?? "Sukses")
      } else {
        defaultToastError(message ?? defaultMessageError)
      }
    } catch (error) {
      defaultToastError(defaultMessageError)
      console.log(defaultMessageError.toUpperCase() + error)
    }
  }
  return (
    <>
      <Dialog
        open={openDelete}
        onClose={() => {
          setOpenDelete(false)
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Konfirmasi Delete Booking {formData.id}
        </DialogTitle>
        <DialogContent dividers>
          <InputTextArea
            label={"KETERANGAN"}
            placeholder={"Keterangan"}
            name="keterangan-batal"
            value={formData.keterangan_batal_jkn}
            onChange={(e) =>
              setFormData({
                ...formData,
                keterangan_batal_jkn: e.target.value,
              })
            }
            id={"keterangan-batal-jkn"}
            rows={"3"}
          />
        </DialogContent>
        <DialogActions>
          <MasterButton
            name="Hapus"
            color="danger"
            type="button"
            onClick={() => confirmDelete()}
          />
        </DialogActions>
      </Dialog>
      <Modal title={`Detail Booking JKN`} show={setShowModal} width="50%">
        {!loadingJKN ? (
          <>
            {Array.isArray(dataJKN) && dataJKN.length > 0 ? (
              dataJKN.map((x, i) => {
                const isSudahDilayani =
                  x.status === ANTREAN_JKN_STATUS.SELESAI_DILAYANI
                const isBelumDilayani =
                  x.status === ANTREAN_JKN_STATUS.BELUM_DILAYANI
                const isBatal = x.status === ANTREAN_JKN_STATUS.BATAL

                return (
                  <>
                    <p
                      style={{
                        background: isSudahDilayani
                          ? "#dcfce7"
                          : isBelumDilayani
                          ? "#fef3c7"
                          : isBatal
                          ? "#fee2e2"
                          : "#f1f5f9",
                        color: isSudahDilayani
                          ? "#15803d"
                          : isBelumDilayani
                          ? "#f59e0b"
                          : isBatal
                          ? "#dc2626"
                          : "#334155",
                        padding: "5px 9px",
                        textAlign: "center",
                        marginBottom: "10px",
                        borderRadius: "10px",
                        marginLeft: "10px",
                        marginRight: "10px",
                      }}
                    >
                      {x.status}
                    </p>
                    <Grid
                      container
                      spacing={1}
                      key={i}
                      style={{ padding: "0 10px" }}
                    >
                      <TableRow label={"Kode Booking"} value={x.kodebooking} />
                      <TableRow label={"NIK KTP"} value={x.nik} />
                      <TableRow label={"Kode Poli"} value={x.kodepoli} />
                      <TableRow label={"No. Antrean"} value={x.noantrean} />
                      <TableRow label={"No. RM"} value={x.norekammedis} />
                      <TableRow label={"Kode Dokter"} value={x.kodedokter} />
                      <TableRow label={"Jam Praktek"} value={x.jampraktek} />
                      <TableRow label={"No. HP"} value={x.nohp} />
                      <TableRow label={"No. Kapst"} value={x.nokapst} />
                      <TableRow label={"No. Ref"} value={x.nomorreferensi} />
                      <TableRow
                        label={"Tanggal"}
                        value={defaultDateDisplay(x.tanggal, false)}
                      />
                      <TableRow label={"Jam Praktek"} value={x.jampraktek} />
                      <TableRow
                        label={"Estimasi Dilayani"}
                        value={defaultDateDisplay(new Date(x.estimasidilayani))}
                      />
                      <TableRow
                        label={"Tanggal Dibuat"}
                        value={defaultDateDisplay(new Date(x.createdtime))}
                      />
                      <TableRow
                        label={"Jenis Kunjungan"}
                        value={renderJenisKunjungan(x.jeniskunjungan)}
                      />
                      <TableRow label={"Sumber Data"} value={x.sumberdata} />
                    </Grid>
                    {withButtonDelete && (
                      <>
                        <Grid
                          container
                          direction="row"
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          <Tooltip title="Batal booking JKN">
                            <span>
                              <MasterButton
                                type={"button"}
                                className={"mt-1"}
                                disabled={!isBatal ? false : true}
                                color={!isBatal ? "danger" : "secondary"}
                                name={
                                  !isBatal
                                    ? "BATAL BOOKING"
                                    : "BOOKING TELAH DIBATALKAN"
                                }
                                outline
                                onClick={() => {
                                  setDataDelete(i)
                                  setOpenDelete(true)
                                }}
                                size="md"
                              />
                            </span>
                          </Tooltip>
                        </Grid>
                      </>
                    )}
                  </>
                )
              })
            ) : (
              <>
                <p
                  style={{
                    background: "#fef3c7",
                    color: "#f59e0b",
                    padding: "5px 9px",
                    textAlign: "center",
                    marginBottom: "10px",
                    borderRadius: "10px",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                >
                  Data status JKN tidak ditemukan
                </p>
              </>
            )}
          </>
        ) : (
          [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
            <Skeleton animation="wave" />
          ))
        )}
      </Modal>
    </>
  )
}

const TableRow = ({ label, value }) => {
  const config = {
    backgroundColor: "#f0f0f0",
    borderRadius: "10px",
    padding: "7px",
  }

  return (
    <>
      <Grid
        item
        sm={6}
        style={{
          display: "flex",
        }}
      >
        <p
          style={{
            width: "48%",
            background: config.backgroundColor,
            padding: config.padding,
            borderTopLeftRadius: config.borderRadius,
            borderBottomLeftRadius: config.borderRadius,
          }}
        >
          {label}
        </p>
        <p
          style={{
            width: "2%",
            background: config.backgroundColor,
            padding: config.padding,
          }}
        >
          :
        </p>
        <p
          style={{
            width: "50%",
            background: config.backgroundColor,
            padding: config.padding,
            borderTopRightRadius: config.borderRadius,
            borderBottomRightRadius: config.borderRadius,
          }}
        >
          {value}
        </p>
      </Grid>
    </>
  )
}
